import { Box, Typography, Container, Link } from '@mui/material';
import { useNavigate } from 'react-router-dom';

const Footer = () => {
  const navigate = useNavigate();

  return (
    <Box
      sx={{
        backgroundColor: "#1f2937",
        color: "#ffffff",
        py: 4,
        mt: "auto",
      }}
    >
      <Container maxWidth="md">
        <Box
          sx={{
            display: "flex",
            flexDirection: "column",
            alignItems: "center",
            textAlign: "center",
          }}
        >
          <Link component="button" variant="h6" onClick={() => navigate('/')} sx={{ color: '#e5e7eb', textDecoration: 'underline', cursor: 'pointer' }}>
            Phoenix Play Zone
          </Link>
          <Typography variant="body2" gutterBottom>
            Address: 55/2 Sri Rathanajothi Mawatha, Galle
          </Typography>
          <Typography variant="body2" gutterBottom>
            Email: pheonixplayzone@gmail.com
          </Typography>
          <Typography variant="body2" gutterBottom>
            Phone: +94 77 760 6279
          </Typography>
          
          <Box sx={{ display: 'flex', gap: 1, mt: 2 }}>
            <Link component="button" variant="body2" onClick={() => navigate('/terms-and-conditions')} sx={{ color: '#e5e7eb', textDecoration: 'underline', cursor: 'pointer' }}>
              Terms & Conditions
            </Link>
            <Link component="button" variant="body2" onClick={() => navigate('/privacy-policy')} sx={{ color: '#e5e7eb', textDecoration: 'underline', cursor: 'pointer' }}>
              Privacy Policy
            </Link>
            <Link component="button" variant="body2" onClick={() => navigate('/refund-policy')} sx={{ color: '#e5e7eb', textDecoration: 'underline', cursor: 'pointer' }}>
              Refund Policy
            </Link>
          </Box>

          <Typography variant="body2" sx={{ mt: 2 }}>
            © {new Date().getFullYear()} Phoenix Play Zone. All rights reserved.
          </Typography>
        </Box>
      </Container>
    </Box>
  );
};

export default Footer;
